import { ref, watch } from 'vue'
import type { Ref } from 'vue'
export function useRatesTableFilter(tableData: Ref<Array<any>>, searchArr: Array<any>) {
  // const allData = ref(JSON.parse(JSON.stringify(tableData)));
  const allData = tableData.value

  const filtered = ref(tableData.value)
  const search = ref(searchArr)
  //this is failing on customer field, as some of them are null
  watch(
    () => search.value,
    (newVal, oldVal) => {
      //console.log("watch called on searchArr.value = " + JSON.stringify(newVal));
      //let lowercase = newVal.map(text=>{
      //  return text.toString().toLowerCase();
      //});
      filtered.value = allData.filter((row) => {
        //console.log("..row = " + JSON.stringify(row));
        const rateId = newVal['id'].toString().toLowerCase();
        const description = newVal['description'].toString().toLowerCase();
        const pileCount = newVal['pileCount'].toString().toLowerCase();
        const rate1 = newVal['rate1'].toString().toLowerCase();
        const rate2 = newVal['rate2'].toString().toLowerCase();
        const notes = newVal['notes'].toString().toLowerCase();
     
        //const invoiceNameRow = row['installer']
        //const emailRow = row['email'];
        return (
          row['id'].toString().toLowerCase().includes(rateId) &&
          row['description'].toString().toLowerCase().includes(description) &&
         // (row['pileCount'].toString().toLowerCase().includes(pileCount) || false) &&
          (row['pileCount'] != ''
            ? pileCount.toString().toLowerCase().includes(pileCount)
            : true) &&
          row['rate1'].toString().toLowerCase().includes(rate1) &&
          //row['rate2'].toString().toLowerCase().includes(rate2) || row['rate2'].toString() === '' &&
          (row['rate2'] != ''
            ? rate2.toString().toLowerCase().includes(rate2)
            : true) &&
          row['notes'].toString().toLowerCase().includes(notes)
        )



        /*  (invoiceNameRow != null
            ? invoiceNameRow.toString().toLowerCase().includes(installer)
            : true)*/

       // )
        //(row['owner'] ? row['owner'].toString().toLowerCase().includes(owner) : false); // &&
        // row['customerName'].toString().toLowerCase().includes(customer) &&
        //rowCust ? rowCust.name.toString().toLowerCase().includes(customer) : false;
        //row.customer.name.toString().toLowerCase().includes(customer) &&
      })
      //filtered.value = props.tableData.filter(row => row[props.columnName].toString().toLowerCase().includes(newVal.toLowerCase()));
    },
    { deep: true }
  )

  return { filtered }
}
